import { PageHeader, Tabs } from '@lmc/ui-kit'
import { PageWrapper } from '../components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import ShiftsForm from './components/ShiftsForm'
import { showToast } from 'common/utils'
import VisitsForm from './components/VisitsForm'
import { useShiftTypesList } from '../hooks/useShiftTypesList'
import { useShiftTypesUpdate } from '../hooks/useShiftTypesUpdate'
import { useVisitTypesList } from '../hooks/useVisitTypesList'
import { useVisitTypesUpdate } from '../hooks/useVisitTypesUpdate'
import { getJSON } from 'common/services/api'
import { useDispatch } from 'react-redux'
import * as GlobalActions from 'actions/Global'
import SettingsPaywall from './components/SettingsPaywall'
import NavigationModal from 'components/NavigationModal/NavigationModal'
import { useState } from 'react'

const HELP_ARTICLE_URL = 'https://support.logmycare.co.uk'

const RotaPatternsSettings = () => {
  const { t } = useTranslation()
  const { shiftTypes, isShiftTypesLoading } = useShiftTypesList()
  const dispatch = useDispatch()

  const [isShiftsFormDirty, setShiftsFormDirty] = useState(false)
  const [isVisitsFormDirty, setVisitsFormDirty] = useState(false)

  const canNavigate = !(isShiftsFormDirty || isVisitsFormDirty)

  const handleRefreshHome = async () => {
    try {
      const res = await getJSON({ url: '/api/init' })
      const { home: homeRefresh } = res.data
      if (res) {
        dispatch(GlobalActions.setHomeDetails(homeRefresh))
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  const { updateShiftTypes } = useShiftTypesUpdate({
    onSuccess: async () => {
      showToast({ title: t('ROTA_SETTINGS_UPDATED') })
      await handleRefreshHome()
    },
  })

  const { visitTypes, flexiVisits, isVisitTypesLoading } = useVisitTypesList()

  const { updateVisitTypes } = useVisitTypesUpdate({
    onSuccess: async () => {
      showToast({ title: t('ROTA_SETTINGS_UPDATED') })
      await handleRefreshHome()
    },
  })

  return (
    <>
      <PageHeader
        title={t('ROTA_PATTERNS')}
        subtitle={t('ROTA_PATTERNS_INFO')}
        moreInfoLink={HELP_ARTICLE_URL}
        sticky
      />
      <PageWrapper>
        <Tabs
          items={[
            {
              key: '1',
              label: <Text>{t('TYPES_SHIFTS')}</Text>,
              children: (
                <SettingsPaywall startingText={t('ROTA_PATTERNS_ARE')}>
                  <ShiftsForm
                    types={shiftTypes}
                    isShiftTypesLoading={isShiftTypesLoading}
                    updateShiftTypes={updateShiftTypes}
                    isDirty={isShiftsFormDirty}
                    setIsDirty={setShiftsFormDirty}
                  />
                </SettingsPaywall>
              ),
            },
            {
              key: '2',
              label: <Text>{t('TYPES_VISITS')}</Text>,
              children: (
                <SettingsPaywall startingText={t('ROTA_PATTERNS_ARE')}>
                  <VisitsForm
                    types={visitTypes}
                    initialFlexiVisits={flexiVisits}
                    isVisitTypesLoading={isVisitTypesLoading}
                    updateVisitTypes={updateVisitTypes}
                    isDirty={isVisitsFormDirty}
                    setIsDirty={setVisitsFormDirty}
                  />
                </SettingsPaywall>
              ),
            },
          ]}
        />
      </PageWrapper>
      <NavigationModal
        canNavigate={canNavigate}
        modalContentText={t('ROTA_SETTINGS_NAVIGATION_MODAL_CONTENT')}
      />
    </>
  )
}

export default RotaPatternsSettings
